export function Headers (accessToken) {

  return { 'headers': { 'Authorization': `JWT ${accessToken}`} }
}